import { type Subscriptions } from "@/utils/db/types";

export function getCreditsRemaning(subscription: Subscriptions) {
  return (
    subscription.maxCredits -
    subscription.creditsUsed +
    subscription.oneTimeCredits
  );
}
